import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import Setup from "./Setup";

// Css
import "./styles/App.css";

ReactDOM.render(
  <BrowserRouter>
    <Setup />
  </BrowserRouter>,
  document.getElementById("root")
);
